import phonePrefixes from '@/constants/phonePrefixes';

export default (value) => {
    let defaultMask = '### ### ###';
    if (value === null) {
        return defaultMask;
    }
    if (value.length > 9) {
        defaultMask = '';
        for (let i = 0; i < value.length; i++) {
            defaultMask += '#';
        }
        defaultMask = defaultMask.replace(/(...)/g, '$1 ');
        return defaultMask;
    }

    const prefix = parseInt(value.substr(0, 2));
    if (phonePrefixes.includes(prefix)) {
        return '## ### ## ##';
    }
    return defaultMask;
};
